import { Col, Row, Button } from "antd";
import React from "react";
import DropdownSelect from "../../../components/generic/DropdownSelect";
import { EyeOutlined } from "@ant-design/icons";

/**
 * DatabaseParameters — reusable database connection section.
 * Shows: Environment → Database
 *
 * Props:
 *   environments  []        — full environment list (filtered internally to those with DBs)
 *   connections   []        — all DB connections from getAllConnection()
 *   value         object    — { environment, database }
 *   onChange      fn(patch) — called with { environment?, database? }
 */
function DatabaseParameters({
  environments = [],
  connections = [],
  value = {},
  onChange,
}) {
  const { environment = "", database = "" } = value;
  const envWithDb = environments.filter((e) => e.databaseCount > 0);
  const dbOptions = environment
    ? connections.filter((c) => c.environmentName === environment)
    : [];

  const onChangeEnvironment = (val) => {
    onChange({ environment: val, database: "" });
  };

  return (
    <div style={{ marginBottom: 4 }}>
      <Row style={{ marginBottom: 8 }}>
        <Col span={6}>
          <p className="spec-modal-label">Environment</p>
        </Col>
        <Col span={16}>
          <DropdownSelect
            placeholder="select environment"
            labelKey="displayName"
            valueKey="displayName"
            options={envWithDb}
            onSelect={onChangeEnvironment}
            value={environment || undefined}
          />
        </Col>
        <Col span={2} style={{ display: "flex", justifyContent: "center" }}>
          <Button type="link">
            <EyeOutlined style={{ fontSize: 22, color: "gray" }} />
          </Button>
        </Col>
      </Row>
      <Row>
        <Col span={6}>
          <p className="spec-modal-label">Database</p>
        </Col>
        <Col span={18}>
          <DropdownSelect
            placeholder="select database"
            options={dbOptions}
            labelKey="displayName"
            valueKey="displayName"
            onSelect={(val) => onChange({ database: val })}
            value={database || undefined}
            disabled={!environment}
          />
        </Col>
      </Row>
    </div>
  );
}

export default DatabaseParameters;
